export default {
  current: '',
  actives: {},
  showNavigationMenu: false,
  cachedTabs: {},
  menuActive: false
};
